module.exports = __webpack_public_path__ + "img/laptop-medical.854c0a8e.svg";